var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
/*
 * @Author: yejianfei
 * @Date: 2023-04-03 22:34:45
 * @LastEditors: yejianfei
 * @LastEditTime: 2023-04-19 22:52:35
 * @Description:
 * @Developer:
 */
import React from 'react';
import AdminPage from '../../components/antd/AdminPage';
import { Button, Card, Col, Form, Input, Row, Space } from 'antd';
import APITable from '../../components/antd/APITable';
import WithRouter from '../../components/WithRouter';
import IconFont from '../../icons';
let AdminQuestionnaireListPage = class AdminQuestionnaireListPage extends React.Component {
    constructor() {
        super(...arguments);
        this.state = {};
    }
    render() {
        return (React.createElement(AdminPage, null,
            React.createElement(Card, { style: { height: '100%' }, bodyStyle: { padding: 12, height: '100%' } },
                React.createElement(APITable, { bordered: true, tableLayout: 'fixed', loader: `/admin/questionnaires/list/:page`, initialParams: {
                        page: 1,
                        size: 25,
                        filters: true
                    }, size: 'small', rowKey: 'id', 
                    // scroll={{y: 100}}
                    pagination: { showSizeChanger: false }, columns: [{
                            title: '问券标题',
                            width: 200,
                            align: 'center',
                            dataIndex: 'title'
                        }, {
                            title: '所属医院',
                            width: 200,
                            align: 'center',
                            dataIndex: 'hospital_name'
                        }, {
                            title: '所属科室',
                            width: 200,
                            align: 'center',
                            dataIndex: 'department_name'
                        }, {
                            title: '诊疗项目',
                            width: 200,
                            align: 'center',
                            dataIndex: 'treatment_item_name'
                        }, {
                            title: '操作',
                            dataIndex: 'operation',
                            align: 'center',
                            width: 200,
                            render: ((text, record, index, instance) => {
                                return (React.createElement(Space, null,
                                    React.createElement(Button, { type: "link", onClick: () => this.props.route.navigate(`form/${record.id}`) }, "\u7F16\u8F91"),
                                    React.createElement(Button, { danger: true, type: "link", onClick: () => instance.delete(record.id) }, "\u5220\u9664")));
                            })
                        }], search: {
                        children: (table) => {
                            return (React.createElement(Row, null,
                                React.createElement(Col, { span: 8 },
                                    React.createElement(Form.Item, { name: ['keywords'] },
                                        React.createElement(Input.Search, { placeholder: '\u8F93\u5165\u95EE\u5238\u6807\u9898\u68C0\u7D22', allowClear: true, enterButton: true, onSearch: () => table.search() }))),
                                React.createElement(Col, { flex: 1 },
                                    React.createElement(Row, { justify: 'end' },
                                        React.createElement(Space, null,
                                            React.createElement(Form.Item, null,
                                                React.createElement(Button, { onClick: () => this.props.route.navigate('form'), icon: React.createElement(IconFont, { type: 'icon-questions-add' }) })))))));
                        }
                    }, form: {
                        title: '问券',
                        action: '/admin/questionnaires',
                        loader: '/admin/questionnaires/:id',
                        name: 'questionnaire-form',
                    } }))));
    }
};
AdminQuestionnaireListPage = __decorate([
    WithRouter()
], AdminQuestionnaireListPage);
export default AdminQuestionnaireListPage;
